module.exports = __webpack_public_path__ + "static/media/bank.3397f5b0.svg";